import gdg from "../assets/img/logos/GDG-Lockup-1Line-Black_vMWBFT9.svg";
import adopta from "../assets/img/logos/adopta.jfif";
import commit from "../assets/img/logos/commit.png";
import EEE from "../assets/img/logos/EEE.png";
import a11y from "../assets/img/logos/a11y.png";
import madvue from "../assets/img/logos/madvue.png";
import salmorejo from "../assets/img/logos/salmorejo.png";
import t3chfest from "../assets/img/logos/t3chfest.jpg";
import technolatinas from "../assets/img/logos/technolatinas.png";
import uni from "../assets/img/logos/uni.png";
import weaaare from "../assets/img/logos/weaaare.png";
import wtm from "../assets/img/logos/wtm.png";
import scb from "../assets/img/logos/scb.png";
import talent from "../assets/img/logos/talent.png";
import jsconf from "../assets/img/logos/jsconf.png";
import codemotion from "../assets/img/logos/codemotion.png";
import uoc from "../assets/img/logos/uoc.png";
import lechazo from "../assets/img/logos/lechazologo.png";
import guarandinga from "../assets/img/logos/guarandinga.JPG";
import wp from "../assets/img/logos/wp.png";
import nerdearla from "../assets/img/logos/nerdearla.webp";

export const conferencesArray  = [
    { alt: "CommitConf", href: "https://commit-conf.com/", image: commit },
    { alt: "t3chFest", href: "https://t3chfest.es/2026/", image: t3chfest },
    { alt: "A11yConf", href: "https://www.a11yconf.com/es", image: a11y },
    { alt: "JSConf", href: "https://www.jsconf.es/", image: jsconf },
    { alt: "Universidad de Nebrija", href: "https://www.nebrija.com/", image: uni },
    { alt: "Talent Arena", href: "https://talentarena.tech/es/", image: talent },
    { alt: "Universitat Oberta Catalunya", href: "https://www.uoc.edu/", image: uoc },
    { alt: "Google Developers Group", href: "https://gdg.community.dev/gdg-madrid/", image: gdg },
    { alt: "Nerdearla Mexico", href: "https://nerdearla.com/", image: nerdearla },
    { alt: "Wordpress Accessibility Day", href: "https://wpaccessibility.day/2026/", image: wp },
    { alt: "MadVue", href: "https://madvue.es/", image: madvue },
    { alt: "LechazoConf", href: "https://lechazoconf.com/", image: lechazo },
    { alt: "Women Tech Makers Madrid", href: "https://wtmgdgmadrid.github.io/", image: wtm },
    { alt: "weAAAre", href: "https://www.weaaare.com/", image: weaaare },
    { alt: "Extremadura Digital Day", href: "https://extremaduradigitalday.com/", image: EEE },
    { alt: "Adopta un junior", href: "https://adoptaunjunior.es/", image: adopta },
    { alt: "Salmorejo Tech", href: "https://salmorejo.tech/2026/", image: salmorejo },
    { alt: "Technolatinas", href: "https://www.a11yconf.com/es", image: technolatinas },
    { alt: "Software Crafter Barcelona", href: "https://softwarecrafters.barcelona/", image: scb },
    { alt: "Codemotion", href: "https://conferences.codemotion.com/madrid/", image: codemotion },
    { alt: "GuarandingaTECH", href: "https://www.youtube.com/@GuarandingaTECH", image: guarandinga },
]